import * as React from 'react';

import s from './InfoBlock.module.css';

type TProps = {
  id?: string;
  as?: React.ElementType;
  children: React.ReactNode;
};

export const InfoBlock = ({ children, as = 'div', id }: TProps) => {
  const Component = as;

  return (
    <Component className={s.infoBlock} id={id}>
      {children}
    </Component>
  );
};
